import React, { Component } from "react";
import "../styles/infoImage.scss";
import Placeholder from "../img/placeholder.jpg";
import { Dialog } from "@material-ui/core";

const InfoImage = ({ imgSrc, title, hasLargeView }) => {
  const [isOpen, setOpen] = React.useState(false);
  const toggleOpen = (open) => {
    if (!imgSrc) return;
    setOpen(!open);
  };
  return (
    <div
      className={
        hasLargeView && imgSrc
          ? "new-call-image-block hasLargeView"
          : "new-call-image-block"
      }
    >
      <img
        src={imgSrc ? imgSrc : Placeholder}
        onClick={() => toggleOpen(isOpen)}
      />
      <Dialog open={isOpen} onClose={() => toggleOpen(isOpen)}>
        <div className="image-modal-container">
          {title && <p>{title}</p>}
          <img src={imgSrc} />
        </div>
      </Dialog>
    </div>
  );
};

export default InfoImage;
